// eslint-disable-next-line no-unused-vars, object-curly-newline
import { ref } from '@vue/composition-api'

export default function useItemList() {
  const itemListTable = ref([])

  const tableColumns = [
    { text: '#', value: 'videoId' },
    { text: 'TITLE', value: 'title' },
    { text: 'DURATION', value: 'duration' },
    { text: 'IMAGE URL', value: 'thumbUrl' },
    {
      text: 'ACTIONS',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]

  const options = ref({
    q: '',
    sortBy: ['sort'],
    sortDesc: [false],
  })

  // onInit
  const init = () => {}

  // onDestroy
  const destroy = () => {}

  return {
    itemListTable,
    tableColumns,

    options,

    init,
    destroy,
  }
}
